export const tableHeadConfig = [
  { id: 1, label: 'Loose Items', isSortable: false },
  { id: 2, label: 'Current Location(Sublocation)', isSortable: false },
  { id: 3, label: 'Available QTY(BAA)', footnote: '[1]', isSortable: false },
  { id: 4, label: 'Add QTY', isSortable: false },
  { id: 5, label: 'From BAA', footnote: '[1]', isSortable: false },
  { id: 6, label: '', isSortable: false }
];
